import status from './status.svg';
import plus from './status-plus.svg';
import minus from './status-minus.svg';
import notAllowed from './not-allowed.svg';
import scissorsOpen from './scissors-open.svg';
import scissorsClosed from './scissors-closed.svg';

export const statusCursor = `url(${status}) 5 5, auto`;

export const plusCursor =  `url(${plus}) 2 5, auto`;

export const minusCursor =  `url(${minus}) 2 5, auto`;

export const scissorsOpenCursor =  `url(${scissorsOpen}) 2 5, auto`;

export const scissorsClosedCursor =  `url(${scissorsClosed}) 2 5, auto`;

export const notAllowedCursor =  `url(${notAllowed}) 2 5, auto`;